import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/client'
import { Button } from 'antd'

import { CurrentLegalFormalityContext } from 'contexts/LegalFormalityContext'
import { LEGAL_FORMALITY_ARCHIVE_DOWNLOAD_MUTATION } from 'graphql/LegalFormalities'
import {
  openErrorPopup,
  openValidationPopup,
} from 'components/ConfirmationPopups'

const FormalityArchiveDownload = () => {
  const { t } = useTranslation('legalFormalities')
  const { legalFormality } = useContext(CurrentLegalFormalityContext)
  const [legalFormalityArchiveDownload] = useMutation(
    LEGAL_FORMALITY_ARCHIVE_DOWNLOAD_MUTATION
  )

  const downloadArchive = () => {
    const variables = { id: legalFormality.id }
    legalFormalityArchiveDownload({ variables }).then((res: any) => {
      if (res.errors) {
        openErrorPopup(res.errors.join(', '), '')
      } else {
        openValidationPopup(t('archive.success', ''), '')
      }
    })
  }

  return (
    <Button onClick={downloadArchive} size="large">
      {t('archive.download')}
    </Button>
  )
}

export default FormalityArchiveDownload
